import useAppStore from "@/context/store";
import { isGdMerged } from "@/utils/gaoding";
import useABTest from "@/utils/hooks/useABtest";

// 判断是否使用新布局
export function useNewLayout() {
  const user = useAppStore(({ user }) => user);

  const layoutABTest = useABTest("hb_layout_update", "string_0");
  return {
    isNewLayout:
      layoutABTest.value !== "string_0" && (!user || isGdMerged(user)),
    version: layoutABTest.value,
  };
}
